/**
 * @generated SignedSource<<72dd837426842645068de66f6ab21db8>>
 * @relayHash 0c6cd7ea8a2617a3774768a2cedba4ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf7a2d41515f4e68d1a53acef19eb20f955d7f34fb7d16d2b6f3c351c6d22ee6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CaseNotesPageQuery } from './CaseNotesPageQuery.graphql';

const node: PreloadableConcreteRequest<CaseNotesPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bf7a2d41515f4e68d1a53acef19eb20f955d7f34fb7d16d2b6f3c351c6d22ee6",
    "metadata": {},
    "name": "CaseNotesPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
